/**
 * Build a Box — shared helpers
 * Used by both sections/build-a-box.liquid and sections/cart-box-summary.liquid
 *
 * These two sections agree on two cart line-item property names so the cart
 * page can find and group items that were added together as one box:
 *   "Box"      – human-readable box label shown to the customer
 *   "_Box ID"  – hidden id (leading underscore hides it from cart/checkout
 *                 display in Shopify) shared by every item added in one
 *                 "Add Box to Cart" click, used only for grouping.
 * If you duplicate the builder section to sell a second kind of box, leave
 * these two property names alone — only the "Box" label text needs to change.
 */
window.BoxBuilder = window.BoxBuilder || {};

BoxBuilder.BOX_LABEL_PROPERTY = 'Box';
BoxBuilder.BOX_ID_PROPERTY = '_Box ID';

/**
 * Minimal implementation of Shopify's money_format tokens, so amounts built
 * in JavaScript (cents) match how the theme formats prices elsewhere.
 * Covers the token styles Shopify themes use in Settings > General > Store
 * currency formatting. Falls back to a plain "$12.34" if the format string
 * doesn't match a known pattern.
 */
BoxBuilder.formatMoney = function (cents, format) {
  cents = Math.round(Number(cents) || 0);
  format = format || '${{amount}}';

  function withCommas(value) {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function withDecimals(numberCents, decimals, decimalSep, thousandSep) {
    var negative = numberCents < 0;
    var abs = Math.abs(numberCents);
    var whole = Math.floor(abs / 100).toString();
    var frac = (abs % 100).toString().padStart(2, '0');
    whole = thousandSep === ',' ? withCommas(whole) : whole;
    var out = decimals ? whole + decimalSep + frac : whole;
    return (negative ? '-' : '') + out;
  }

  var value;
  if (/amount_no_decimals_with_comma_separator/.test(format)) {
    value = withDecimals(cents, false, '.', ',');
  } else if (/amount_with_comma_separator/.test(format)) {
    value = withDecimals(cents, true, ',', '.');
  } else if (/amount_no_decimals/.test(format)) {
    value = withDecimals(cents, false, '.', ',');
  } else {
    value = withDecimals(cents, true, '.', ',');
  }

  return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, value);
};

/** Small debounce so a customer typing/holding +/- doesn't fire a request per keystroke. */
BoxBuilder.debounce = function (fn, wait) {
  var t;
  return function () {
    var args = arguments, ctx = this;
    clearTimeout(t);
    t = setTimeout(function () { fn.apply(ctx, args); }, wait);
  };
};

BoxBuilder.escapeHtml = function (str) {
  var div = document.createElement('div');
  div.textContent = str == null ? '' : String(str);
  return div.innerHTML;
};